import React from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const ApiResponseError = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p> {props.t('sorry')}, {props.t('server_is_taking_to_long_to_respond_please_try_again_in_sometime')}.</p>
            <p> {props.t('thank_you')}.</p>
        </div>
    )
}

ApiResponseError.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ApiResponseError)
